import { gql } from '@apollo/client';

// Input types for Profile Attribute GraphQL operations
export interface CreateProfileAttributeInputType {
  agent_id: string;
  name: string;
  dataType: 'text' | 'number' | 'boolean' | 'date' | 'closelist' | 'openlist';
  description?: string;
  useAI: boolean;
  closelist?: {
    options: string[];
    multiple: boolean;
  };
}

export interface UpdateProfileAttributeInputType {
  agent_id: string;
  attribute_id: string;
  name?: string;
  dataType?: 'text' | 'number' | 'boolean' | 'date' | 'closelist' | 'openlist';
  description?: string;
  useAI?: boolean;
  closelist?: {
    options: string[];
    multiple: boolean;
  };
}

export interface DeleteProfileAttributeInputType {
  agent_id: string;
  attribute_id: string;
}

export interface GetProfileAttributeInputType {
  agent_id?: string;
  limit?: number;
  offset?: number;
}


export const CREATE_PROFILE_ATTRIBUTE = gql`
  mutation create_profile_attribute($data: CreateProfileAttributeInputType) {
    create_profile_attribute(data: $data) {
      hasError
      data
      message
    }
  }
`;

export const UPDATE_PROFILE_ATTRIBUTE = gql`
  mutation update_profile_attribute($data: UpdateProfileAttributeInputType) {
    update_profile_attribute(data: $data) {
      hasError
      data
      message
    }
  }
`;

export const DELETE_PROFILE_ATTRIBUTE = gql`
  mutation delete_profile_attribute($data: DeleteProfileAttributeInputType) {
    delete_profile_attribute(data: $data) {
      hasError
      data
      message
    }
  }
`;



export const GET_PROFILE_ATTRIBUTES = gql`
  query get_profile_attributes($data: GetProfileAttributeInputType) {
    get_profile_attributes(data: $data) {
      hasError
      message
      data
    }
  }
`;
 